import React from 'react';
import { Box, Container, useTheme } from '@mui/material';
import { Outlet } from 'react-router';

const Login = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: 'center',
          bgcolor: isDarkMode ? theme.palette.background.default : theme.palette.backgroundColors.default,
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            borderRadius: '10px',
            boxShadow: '0px 1px 5px #0000001A;',
            padding: '0px !important',
            margin: '25px',
            width: 'calc(100% - 50px)',
          }}
        >
          <Outlet />
        </Container>
      </Box>
    </>
  );
};

export default Login;
